import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlurkComponent } from './simple-icons-plurk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlurkComponent ],
    exports:      [ SimpleIconsPlurkComponent ],
    bootstrap:    []
})
export class SimpleIconsPlurkModule {}
